<template>
  <div
    :class="tagClasses"
    class="inline-flex items-center gap-1 px-2 py-0.5 text-xs font-medium rounded-full transition-all duration-150"
    @click="handleClick"
  >
    <Icon
      v-if="icon"
      :name="icon"
      size="12"
    />
    <span v-if="label">{{ label }}</span>
    <slot />
  </div>
</template>

<script setup lang="ts">
interface Props {
  icon?: string
  label?: string
  variant?: 'blue' | 'cyan' | 'purple' | 'yellow' | 'orange' | 'lime' | 'indigo' | 'green' | 'red' | 'emerald' | 'amber' | 'gray'
  clickable?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  variant: 'gray',
  clickable: false,
})

const emit = defineEmits<{
  click: [event: MouseEvent]
}>()

const tagClasses = computed(() => {
  const baseClasses = []

  if (props.clickable) {
    baseClasses.push('cursor-pointer hover:scale-105')
  }

  const variantMap: Record<string, string> = {
    blue: 'bg-blue-100 text-blue-800 border border-blue-200',
    cyan: 'bg-cyan-100 text-cyan-800 border border-cyan-200',
    purple: 'bg-purple-100 text-purple-800 border border-purple-200',
    yellow: 'bg-yellow-100 text-yellow-800 border border-yellow-200',
    orange: 'bg-orange-100 text-orange-800 border border-orange-200',
    lime: 'bg-lime-100 text-lime-800 border border-lime-200',
    indigo: 'bg-indigo-100 text-indigo-800 border border-indigo-200',
    green: 'bg-green-100 text-green-800 border border-green-200',
    red: 'bg-red-100 text-red-800 border border-red-200',
    emerald: 'bg-emerald-100 text-emerald-800 border border-emerald-200',
    amber: 'bg-amber-100 text-amber-800 border border-amber-200',
    gray: 'bg-gray-100 text-gray-800 border border-gray-200',
  }

  baseClasses.push(variantMap[props.variant] || variantMap.gray)

  return baseClasses.join(' ')
})

const handleClick = (event: MouseEvent) => {
  if (props.clickable) {
    emit('click', event)
  }
}
</script>
